import { all, takeLatest, put, select, call } from 'redux-saga/effects';
import LocalStorage from 'yoda-core-components/lib/helpers/LocalStorage/LocalStorage';
import {
    SET_ZONE_PARAM,
    PRODUCTS_BY_ID_SUCCESS_FOR_COMPARE,
} from 'yoda-site-components/lib/actionTypes/ProductComparisionActionTypes';
import ACTIVATE_PRODUCT_COMPARE from '../actionTypes/ProductCompareSummaryBoxActionTypes';
import { getZoneParams, getPageType } from '../utils';
// import { compareSaga } from './ProductCompareSaga';

const getSelectedProducts = (state) => state.compareProducts;

const getCategoryName = (state) => state.commonData.categoryName;

const getRequestUrl = (state) => state.commonData.requestUrl;

function* getProductsToCompare(action) {
    try {
        const { pathname, query, search } = action.payload.location;
        const compareProducts = LocalStorage.getData('compareProducts', true);
        const pageType = getPageType();
        let getUniqueID = '';
        if (pageType === 'g') {
            getUniqueID = yield select(getCategoryName);
        } else {
            getUniqueID = getZoneParams(pathname, query).Ntt;
            // If Ntt is not present in url then search in request URL
            if (getUniqueID) {
                const requestUrl = yield select(getRequestUrl);
                getUniqueID = getZoneParams(requestUrl, query).Ntt;
            }
        }
        // Appending uniqueId with pageType to differentiate search and gallery
        const newZoneParam = `${getUniqueID}-${pageType}`;

        const selectedProducts = yield select(getSelectedProducts);
        const { products, zoneParam } = selectedProducts;

        // If zone param is changed then set zone param in ProductComparisionReducer
        if (zoneParam !== newZoneParam) {
            yield put({
                type: SET_ZONE_PARAM,
                payload: {
                    zoneParam: newZoneParam,
                    refUrl: `${pathname}${search}`,
                },
            });
        } else {
            // To update local storage - If user remove product from 'Compare page' - Start
            const storeProductsToCompare = {
                zoneParam: newZoneParam,
                products: products.map((product) => product.ppId),
            };
            LocalStorage.setData('compareProducts', storeProductsToCompare, true);
        }

        if (!products.length && compareProducts) {
            const storageProducts = JSON.parse(compareProducts);
            const productsList = storageProducts.products.join();
            if (productsList && storageProducts.zoneParam === newZoneParam) {
                const payload = yield call(compareProducts, productsList);
                yield all([
                    put({
                        type: PRODUCTS_BY_ID_SUCCESS_FOR_COMPARE,
                        payload,
                        productsZoneParam: newZoneParam,
                    }),
                ]);
            }
        }
    } catch (error) {
        yield put({ type: 'GET_PRODUCT_DETAILS_BY_ID_ERROR', error });
    }
}

const watchProductCompareSummaryRequest = function* watchProductCompareSummaryRequest() {
    yield takeLatest(ACTIVATE_PRODUCT_COMPARE, getProductsToCompare);
};
watchProductCompareSummaryRequest.sagaName = 'watchProductCompareSummaryRequest';

export default watchProductCompareSummaryRequest;
